import { getController } from '@/services/service'

const url = 'communication_types'

export const communicationTypeService = {
	...getController(url),
}

export default communicationTypeService
